import "./modal.js";
import "#legacy/admin/form.js";
import "./modals/image_dialog/device_cropper_tab.js";
import "#legacy/admin/components/asset_uploader.js";

/**
 * @module page-builder
 */
(function () {
  "use strict";

  function uploadAsset(file, progressCallback) {
    var uploader = new Sparkle.AssetUploader({
      progress: progressCallback,
      fail: function (event) {
        if (event.statusText !== "abort") {
          Sparkle.PageBuilder.Dialog.show({
            title: "Upload failed",
            text: "We could not upload this file because of an error.",
            type: "warning",
          });
        }
      },
    });
    return uploader.upload(file);
  }

  var ImageDialog = function ImageDialog() {
    var _super = new Sparkle.PageBuilder.Modal.Deprecated();
    var self = {};

    _.extend(self, _super, {
      template: "image-dialog",
      initialize: function (initialValue, callback, options) {
        _super.initialize.apply(this, []);

        this.options = options || {};

        if (_.isEmpty(initialValue)) {
          initialValue = null;
        }

        if (this.options.advanced_options) {
          jQuery(this.dialog).addClass("image-cropper--advanced-options");
        }

        var segments = this.dialog.querySelector(".pane-header .segments");

        this.addButton(
          "Remove",
          function () {
            if (callback) {
              callback(null);
            }

            this.remove();
          }.bind(this),
        );

        this.addPrimaryButton(
          "Done",
          function () {
            if (callback) {
              callback(this.getValue());
            }

            this.remove();
          }.bind(this),
        );
        this.doneButton = this.dialog.querySelector(".pane-footer button.primary");

        // The base modal's "X" only tears down the DOM. Wire it to onCancel when
        // supplied (the slideshow add flow) so an unconfirmed slide is cleaned up.
        if (this.options.onCancel && this.closeButton) {
          this.closeButton.addEventListener("click", this.options.onCancel);
        }

        this.setupSearch();
        this.setupUploader();
        this.setValue(initialValue);

        if (this.value) {
          // Render the edit tab even for the add flow's imageless value, so
          // manually opening that tab doesn't show an empty pane.
          this.editAsset(this.value);
        }

        if (!this.hasImage()) {
          this.switchTo("image-search-tab");
        }

        Sparkle.Tabs.initializeTabs(this.dialog);
        this.show();
      },

      setupSearch: function () {
        var queryElement = this.dialog.querySelector("[name=query]");
        var queryResultsElement = this.dialog.querySelector(".results");

        var search = _.debounce(
          function () {
            var url = "/admin/assets.json";
            var params = { query: queryElement.value, page_type: "Image", limit: 50, archived: false, wildcard: true };

            jQuery.get(url, params).done(
              function (json) {
                queryResultsElement.innerHTML = "";

                json.forEach(
                  function (result) {
                    var element = document.createElement("li");
                    element.innerHTML = Sparkle.HandlebarsTemplates["image-dialog-search-result"](result);
                    element.addEventListener(
                      "click",
                      function () {
                        this.selectAsset(result);
                      }.bind(this),
                    );

                    queryResultsElement.appendChild(element);
                  }.bind(this),
                );
              }.bind(this),
            );
          }.bind(this),
          300,
        );

        queryElement.addEventListener("input", search);
        search();
      },

      setupUploader: function () {
        var uploadArea = this.dialog.querySelector(".image-upload-tab");
        var fileElement = this.dialog.querySelector("[name=files]");

        var processFile = function (file) {
          var dialog = this.dialog;
          var progressTab = dialog.querySelector(".upload-progress-tab");
          var progressContainer = progressTab.querySelector(".progress-container");
          var cancelButton = progressTab.querySelector("button");

          progressTab.style.display = "block";
          jQuery(progressContainer)
            .html(jQuery("<small>").text(file.name))
            .append("<div class='progressbar'><div style='width: 0%;' /></div>");
          dialog.classList.add("uploading");

          var finishUpload = function finishUpload() {
            progressTab.style.display = "none";
            dialog.classList.remove("uploading");
          };

          var progressBar = progressContainer.querySelector(".progressbar div");
          var progress = function progress(event) {
            var percent = parseInt((event.loaded / event.total) * 100, 10);
            progressBar.style.width = percent + "%";
          };

          var upload = uploadAsset(file, progress);
          upload.then(
            function (response) {
              this.selectAsset(response);
              finishUpload();
            }.bind(this),
          );

          cancelButton.addEventListener("click", function () {
            upload.abort();
            finishUpload();
          });
        }.bind(this);

        // Upload: Dialog
        fileElement.addEventListener("change", function () {
          processFile(fileElement.files[0]);
        });

        // Upload: Drag'n'drop
        uploadArea.addEventListener("dragover", function (event) {
          event.preventDefault();
        });

        uploadArea.addEventListener("dragenter", function (event) {
          uploadArea.classList.add("drag-over");
        });

        uploadArea.addEventListener("dragleave", function (event) {
          uploadArea.classList.remove("drag-over");
        });

        uploadArea.addEventListener("dragend", function (event) {
          uploadArea.classList.remove("drag-over");
        });

        uploadArea.addEventListener("drop", function (event) {
          uploadArea.classList.remove("drag-over");
          event.preventDefault();
          event.stopPropagation();
          processFile(event.dataTransfer.files[0]);
        });
      },

      getValue: function () {
        return this.value;
      },

      setValue: function (value) {
        this.value = value;

        // Done hands the current value to the caller — without a selected image
        // that would produce a broken, imageless slide (or save an empty asset).
        this.doneButton.disabled = !this.hasImage();
      },

      hasImage: function () {
        return !!(this.value && (this.value.id || this.value.url));
      },

      selectAsset: function (asset) {
        this.setValue(asset);
        this.editAsset(asset);
      },

      switchTo: function (tab) {
        jQuery(this.dialog)
          .find("[aria-controls=" + tab + "]")
          .trigger("click");
      },

      editAsset: function (asset) {
        var dialog = this.dialog;
        // Update image element
        var selectedImageElement = dialog.querySelector(".image-edit-tab");

        var deviceOptions;
        // Don't allow cropping of SVGs
        if (asset.format !== "svg") {
          deviceOptions = this.options.variants;
        }

        var name = asset.url && asset.url.split("/").slice(-1)[0];
        selectedImageElement.innerHTML = Sparkle.HandlebarsTemplates["image-dialog-edit"]({
          url: asset.hi_res_url || asset.url,
          id: asset.id,
          alt: asset.alt,
          title: asset.title,
          variants: asset.variants,
          name: name,
          croppers: deviceOptions,
          cropperItems: this.options.cropperItems || {},
          placeholders: this.options.placeholders,
        });

        Form.decorate(dialog);

        var titleInput = selectedImageElement.querySelector("[name=title]");
        var altInput = selectedImageElement.querySelector("[name=alt]");

        titleInput.addEventListener("input", function () {
          asset.title = titleInput.value;
        });
        altInput.addEventListener("input", function () {
          asset.alt = altInput.value;
        });

        if (deviceOptions) {
          var deviceCropperTabs = {};

          if (!asset.variants) {
            asset.variants = {};
          }

          jQuery.each(deviceOptions, function (deviceName, deviceRatios) {
            var container = jQuery(dialog).find("#" + deviceName + "-cropper-content");
            var activeCropIcon = jQuery(dialog)
              .find(".image-preview")
              .find("#active-" + deviceName + "-crop-icon");
            deviceCropperTabs[deviceName] = new Sparkle.PageBuilder.DeviceCropperTab(
              container,
              asset,
              deviceName,
              deviceRatios,
              activeCropIcon,
            );
          });

          jQuery(dialog).on("change", ".cropper-tabs [data-behaviour=tabstate]", function () {
            var deviceName = jQuery(this).data("device-name");

            if (!deviceCropperTabs[deviceName].enabled) {
              deviceCropperTabs[deviceName].enable();
            }
          });
        }

        this.switchTo("image-edit-tab");

        jQuery(selectedImageElement).find("input:radio[data-behaviour=tabstate]:checked").trigger("change");
      },
    });

    self.initialize.apply(self, arguments);
    return self;
  };

  Sparkle.PageBuilder.ImageDialog = ImageDialog;
  Sparkle.PageBuilder.uploadAsset = uploadAsset;
})();
